var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"timer"},[_c('p',{on:{"change":function($event){return _vm.stopTimer($event)}}},[_vm._v("ارسال مجدد کد تا "+_vm._s(_vm.timer)+" ثانیه دیگر")])])}
var staticRenderFns = []

export { render, staticRenderFns }